import React from 'react'
import moment from 'moment'
import { func, shape, object, string, number, array, oneOfType } from 'prop-types'
import { translate } from 'react-i18next'
import { ProfilePicture } from '../ui/ProfilePicture'
import { InquiryTypes } from '../../constants/InquiryTypes'

export const InquiryDetailsProposal = translate()(({ t, proposal, type, frequency, children, only }) => {
  if (only && only !== proposal.id) {
    return (<span />)
  }

  const date = (() => {
    if (!proposal.maintenance || !proposal.maintenance.interventions || !proposal.maintenance.interventions.length) {
      return proposal.date
    }
    return proposal.maintenance.interventions[0].interventionDate
  })()

  const monthly = (() => {
    if (!proposal.maintenance || !proposal.maintenance.interventions || !proposal.maintenance.interventions.length) {
      return false
    }
    return proposal.maintenance.interventions[0].monthly
  })()

  return (
    <div className='demandes__third'>
      <div>
        <ProfilePicture size={120} picture={proposal.profilePicture} className='img--avatar' alt='picture' />
      </div>

      {/* Gardeners informations */}
      <div className='demande__mainspace'>
        <p className='demandes__gardener-name'>{proposal.name}</p>
        {/* Do not display 'Proposition d'intervention' if its a visit  */}
        {
          type === InquiryTypes.REALISATION
          ? <p className='demandes__proposition'>{t(`common:${frequency.toLowerCase()}:proposal_intervention`)}</p>
          : ''
        }
        {
          /* A visit accepted from the back office may have no date yet: show a "to be determined"
             message instead of a (falsy / 1970) date. `date` is 0 when the backend has no visit date. */
          date
          ? <p className='demandes__currenttext'>{t('common:fields:date')}: {moment.unix(date).format(monthly ? 'MMMM YYYY' : 'DD/MM/YYYY')}</p>
          : <p className='demandes__currenttext'>{t('common:visits:date_to_be_determined')}</p>
        }
        {
          date && !monthly &&
          <p className='demandes__currenttext'>{t('common:fields:hour_arrival')}: {moment.unix(date).format('HH:mm')}</p>
        }
        {
          proposal.duration
          ? <p className='demandes__currenttext'>{t('common:fields:duration')} {moment.duration(proposal.duration * 1000).hours()} h {moment.duration(proposal.duration * 1000).minutes()} min</p>
          : ''
        }
        {
          proposal.maintenance && proposal.maintenance.nbHours !== undefined
          ? <p className='demandes__currenttext'>{t('common:maintenance:nb_hours')}: {proposal.maintenance.nbHours}h</p>
          : ''
        }
      </div>

      {/* Actions */}
      <div>{ children }</div>
    </div>
  )
})

InquiryDetailsProposal.propTypes = {
  t: func,
  only: string,
  proposal: shape({
    id: string,
    profilePicture: object,
    name: string,
    date: number,
    duration: number,
    maintenance: shape({
      nbHours: number
    })
  }),
  type: string,
  frequency: string,
  children: oneOfType([ array, object ])
}



// WEBPACK FOOTER //
// ./src/components/inquiries/InquiryDetailsProposal.js